<template>
<default>
  <div class="tw-w-full">
    <vue-json-to-csv
     :json-data="statement"
     :labels="{
      mtranDate: { title: 'Transaction Date'},
      debitCredit: { title: 'Debit/Credit'},
      narration: { title: 'Narration'},
      totalAmount: { title: 'Total Amount'},
      insured: { title: 'Insured'},
      polPolicyCoverFrom: { title: 'Cover From'},
      polPolicyCoverTo: { title: 'Cover To'},
      proDesc: { title: 'Product'},
      polPolicyNumber: { title: 'Policy Number'},
      }"
     :csv-title="'Statement'"
>
     <v-btn color="success" class="mr-6">
          Export <i class="mdi mdi-export-variant" aria-hidden="true"></i>
     </v-btn>
</vue-json-to-csv>
    <v-data-table
      :headers="headers"
      :items="statement"
      item-key="name"
      class="elevation-1"
    >
    </v-data-table>
  </div>
</default>
</template>

<script>

import axios from 'axios';
import VueJsonToCsv from 'vue-json-to-csv';
import Default from '../components/layout/Default';

export default {
  name: 'ViewStatements',
  components: { Default, VueJsonToCsv },
  data() {
    return {
      headers: [
        // { text: 'Batch No', value: 'mtranNo' },
        { text: 'Transaction Date', value: 'mtranDate' },
        { text: 'Debit/Credit', value: 'debitCredit' },
        { text: 'Narration', value: 'narration' },
        // { text: 'Reference', value: 'referenceNo' },
        // { text: 'Training Levy', value: 'trainingLevy' },
        // { text: 'Stamp Duty', value: 'stampDuty' },
        // { text: 'Other Taxes', value: 'otherTaxes' },
        // { text: 'Policy Holder Fund', value: 'policyholderFund' },
        { text: 'Total Amount', value: 'totalAmount' },
        { text: 'Insured', value: 'insured' },
        { text: 'Cover From', value: 'polPolicyCoverFrom' },
        { text: 'Cover To', value: 'polPolicyCoverTo' },
        { text: 'Product', value: 'proDesc' },
        { text: 'Policy Number', value: 'polPolicyNumber' },
      ],
      statement: [],
    };
  },
  computed: {
    client() {
      return this.$store.getters.clientData;
    },
  },
  mounted() {
    this.init();
  },
  // updated() {
  //   // this.componentKey += 1;
  //   this.init();
  // },
  methods: {
    init() {
      if (!this.$store.state.clientLoading && this.client !== null) this.getStatement(`/customer/gis/policies/statement?clientCode=${this.client.clientCode}`);
    },
    getStatement(url) {
      axios.get(url)
        .then((response) => {
          this.statement = response.data.object;
        });
    },
  },

};
</script>
